'use client';

import { useEffect } from 'react';
import { initSecurityChecks } from '@/lib/utils/security';
import { isFirebaseConfigured } from '@/lib/meeting-reminders/firebase-messaging';
import { isMeetingReminderRegistration } from '@/lib/meeting-reminders/worker-registration';

/**
 * Runs security checks (anti-clickjacking / iframe detection) on mount.
 */
export function ServiceWorkerCleanup() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations
          // Keep the reminder worker only when Firebase is configured; every other worker is stale.
          .filter((registration) => !(isFirebaseConfigured() && isMeetingReminderRegistration(registration)))
          .forEach((registration) => registration.unregister());
      });
    }

    initSecurityChecks();
  }, []);

  return null;
}
